import React from 'react'
import {PaymentProvider} from './PaymentProvider'
import PaymentRequest from './PaymentRequest'
import {ListViewProvider} from './core/ListViewProvider'
import {Helmet} from 'react-helmet-async'

const Payment = () => {
  return (
    <PaymentProvider>
      <ListViewProvider>
        <Helmet>
          <title>Payment Request</title>
        </Helmet>
        <PaymentRequest />
      </ListViewProvider>
    </PaymentProvider>
  )
}

export default Payment
